module.exports = __webpack_public_path__ + "img/drill4_7-7-2021.e5365b59.jpg";